import Vue from "vue";
import Router from "vue-router";
import routes from "@/router/routes/public.js";
import NotFound from "@/pages/public/NotFound";
import { trackPageView } from "@/utils/analytics";

Vue.use(Router);

let router = new Router({
    mode : "history",
    routes: [
    {
        path: "/",
        name: "Home"
    }
    ].concat(routes, [
        // The trial campaign emails link to /contact-us, which never existed:
        // their contact button showed an empty page from 29 Sep 2026. Keeps the
        // campaign tags.
        { path: "/contact-us", redirect: (to) => ({ path: "/contact", query: to.query, hash: to.hash }) },
        // Last: anything the site does not know gets a page with a way on.
        { path: "*", name: "NotFound", component: NotFound }
    ])
});

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    if(to.path == '/') {
        // Keep the query and hash: campaign tags on a link to the homepage
        // must survive this redirect.
        return next({
            path: "/homepage",
            query: to.query,
            hash: to.hash
        });
    }else{
        next();
    }

});

// One page view per navigation, sent by us rather than by Google so the
// address is cleaned first. The short wait lets vue-meta set the new title.
// trackPageView sends nothing without analytics consent (nor while
// scripts/prerender.js renders pages, which runs with no consent).
router.afterEach((to) => {
    setTimeout(() => trackPageView(to), 100);
});

export default router;
